package co.maytes.standupbot.dashboard.features.releases

import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLParameter

data class ReleaseFeedView(
    val filters: ReleaseFilters = ReleaseFilters(),
    val grouping: FeedGrouping = FeedGrouping.Date,
)

object ReleaseFeedUrlState {
    private const val QUERY = "q"
    private const val KIND = "kind"
    private const val RANGE = "range"
    private const val REPOS = "repos"
    private const val GROUP = "group"
    private const val REPO_SEPARATOR = ","

    private val kindKeys = mapOf(KindFilter.Releases to "releases", KindFilter.PullRequests to "prs")
    private val rangeKeys = mapOf(RangeFilter.Week to "7", RangeFilter.Month to "30", RangeFilter.Quarter to "90")

    fun encode(view: ReleaseFeedView): String {
        val filters = view.filters
        val pairs =
            listOfNotNull(
                filters.query.trim().takeIf { it.isNotEmpty() }?.let { QUERY to it.encodeURLParameter() },
                kindKeys[filters.kind]?.let { KIND to it },
                rangeKeys[filters.range]?.let { RANGE to it },
                filters.repos.takeIf { it.isNotEmpty() }
                    ?.let { REPOS to it.sorted().joinToString(REPO_SEPARATOR) { repo -> repo.encodeURLParameter() } },
                (GROUP to "repo").takeIf { view.grouping == FeedGrouping.Repository },
            )
        return if (pairs.isEmpty()) "" else pairs.joinToString("&", prefix = "?") { (key, value) -> "$key=$value" }
    }

    fun decode(search: String): ReleaseFeedView {
        val params =
            search.removePrefix("?").split("&").filter { it.contains("=") }.associate {
                it.substringBefore("=") to it.substringAfter("=")
            }
        val repos =
            params[REPOS].orEmpty().split(REPO_SEPARATOR)
                .map { it.decodeURLQueryComponent(plusIsSpace = true) }
                .filter { it.isNotBlank() }
                .toSet()
        val filters =
            ReleaseFilters(
                query = params[QUERY]?.decodeURLQueryComponent(plusIsSpace = true).orEmpty(),
                kind = kindKeys.entries.firstOrNull { it.value == params[KIND] }?.key ?: KindFilter.All,
                range = rangeKeys.entries.firstOrNull { it.value == params[RANGE] }?.key ?: RangeFilter.All,
                repos = repos,
            )
        val grouping = if (params[GROUP] == "repo") FeedGrouping.Repository else FeedGrouping.Date
        return ReleaseFeedView(filters, grouping)
    }
}
